import { render, staticRenderFns } from "./SportPosition.vue?vue&type=template&id=04aa7dd3&scoped=true&"
import script from "./SportPosition.vue?vue&type=script&lang=js&"
export * from "./SportPosition.vue?vue&type=script&lang=js&"
import style0 from "./SportPosition.vue?vue&type=style&index=0&id=04aa7dd3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04aa7dd3",
  null
  
)

export default component.exports